var map = {
	"./DSCF6636.jpg": 2828,
	"./DSCF6668.jpg": 7564,
	"./DSCF6675.jpg": 2103,
	"./DSCF6699.jpg": 3794,
	"./DSCF6714.jpg": 6457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4147;